import { LoadableAfterPaint } from '@confluence/loadable';

export const DraftStatus = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-banner-itemsdraft-statusDraftStatus" */ '../src/banner-items/draft-status/DraftStatus'
			)
		).DraftStatus,
});
